import { isNil } from 'lodash';
import React from 'react';
import { View as RNView, StyleSheet } from 'react-native';
import { EditField } from '@shared/scenes/entity/components/fields/EditField';
import { getFieldError } from '@shared/scenes/entity/util/getFieldError';
import { grid } from '@shared/styles';
import { EntityFormProps } from './EntityFormProps';

export function EntityFormStatic({
  fields,
  updateField,
  components,
  errors,
  workflowTemplateId,
  entityId,
  style,
  isAuthenticated = true,
}: EntityFormProps) {
  if (isNil(fields) || isNil(workflowTemplateId)) {
    return null;
  }

  return (
    <RNView style={[styles.content, style]}>
      {components.map(component => (
        <EditField
          key={component.id}
          field={fields[component.id]}
          fields={fields}
          workflowTemplateId={workflowTemplateId}
          component={component}
          updateField={updateField}
          error={getFieldError(errors, component.id)}
          entityId={entityId}
          isAuthenticated={isAuthenticated}
        />
      ))}
    </RNView>
  );
}

const styles = StyleSheet.create({
  content: {
    paddingTop: grid(1),
    paddingBottom: grid(8),
  },
});
